import { call, put, all, takeEvery } from "redux-saga/effects";

import { rattingCommentActions } from '../slice/rattingCommentSlice'
import { getPointApi, createRateApi, getRattingDataApi, removeRateApi, updateRateApi } from 'services/rattingCommentServices'
import ShowToast from "utils/ShowToast";


function* getPointSaga(action) {
    try {
        const res = yield call(getPointApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(rattingCommentActions.getRattingPointSuccess({ data: response.data, point: response.point }))
            }
            else {
                yield put(rattingCommentActions.getRattingPointFailed())
            }
        }
        else {
            yield put(rattingCommentActions.getRattingPointFailed())
        }
    } catch (error) {
        yield put(rattingCommentActions.getRattingPointFailed())
    }
}

function* getRattingData(action) {
    try {
        const res = yield call(getRattingDataApi, action.payload.id, action.payload.currentPage, action.payload.sort, action.payload.star)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(rattingCommentActions.getRattingDataSuccess({ data: response.data, totalPage: response.totalPage, dataAccount: response.dataAccount }))
            }
            else {
                yield put(rattingCommentActions.getRattingDataFailed())
            }
        }
        else {
            yield put(rattingCommentActions.getRattingDataFailed())
        }
    } catch (error) {
        yield put(rattingCommentActions.getRattingDataFailed())
    }
}

function* createRateSaga(action) {
    try {
        const res = yield call(createRateApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(rattingCommentActions.createSuccess())
                action.payload.setInputCommentRating && action.payload.setInputCommentRating("")
                action.payload.setInputReply && action.payload.setInputReply("")
                if (action.payload.isRate)
                    ShowToast("success", "Đánh giá tour thành công!")
                if (!action.payload.isRate)
                    ShowToast("success", "Bình luận thành công!")

                action.payload.callBack()
            }
            else {
                yield put(rattingCommentActions.createFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(rattingCommentActions.createFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(rattingCommentActions.createFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}


function* updateRateSaga(action) {
    try {
        const res = yield call(updateRateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(rattingCommentActions.updateRattingSuccess())
                ShowToast("success", "Cập nhật đánh giá thành công!")

                action.payload.callBack()
            }
            else {
                yield put(rattingCommentActions.updateRattingFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(rattingCommentActions.updateRattingFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(rattingCommentActions.updateRattingFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}
function* blockRateSaga(action) {
    try {
        const res = yield call(updateRateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(rattingCommentActions.blockRattingSuccess())
                ShowToast("success", "Ẩn đánh giá thành công!")

                action.payload.callBack()
            }
            else {
                yield put(rattingCommentActions.blockRattingFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(rattingCommentActions.blockRattingFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(rattingCommentActions.blockRattingFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}


function* removeRateSaga(action) {
    try {
        const res = yield call(removeRateApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(rattingCommentActions.removeRattingSuccess())
                ShowToast("success", "Xóa đánh giá thành công!")

                action.payload.callBack()
            }
            else {
                yield put(rattingCommentActions.removeRattingFailed())
                ShowToast("error", "Thất bại, vui lòng thử lại sau!")
            }
        }
        else {
            yield put(rattingCommentActions.removeRattingFailed())
            ShowToast("error", "Thất bại, vui lòng thử lại sau!")
        }
    } catch (error) {
        yield put(rattingCommentActions.removeRattingFailed())
        ShowToast("error", "Thất bại, vui lòng thử lại sau!")
    }
}

export default function* rootSaga() {
    yield all(
        [
            takeEvery(rattingCommentActions.getRattingPoint.type, getPointSaga),
            takeEvery(rattingCommentActions.create.type, createRateSaga),
            takeEvery(rattingCommentActions.getRattingData.type, getRattingData),
            takeEvery(rattingCommentActions.removeRatting.type, removeRateSaga),
            takeEvery(rattingCommentActions.updateRatting.type, updateRateSaga),
            takeEvery(rattingCommentActions.blockRatting.type, blockRateSaga),
        ]
    )
}
